import { ScopeLocationState } from "@state/scopeContext";
import { useScope } from "@state/scopeContext.lib";
import { useMemo } from "react";

// Prevents unstable location state and only selects the fields needed to be persisted for the scope
export function usePersistedLocationState(): ScopeLocationState {
    const { workspaceId, organizationId } = useScope();

    return useMemo(
        () => ({
            workspaceId,
            organizationId,
        }),
        [workspaceId, organizationId],
    );
}
